import { render, staticRenderFns } from "./FilesSearch.vue?vue&type=template&id=9b947bf0"
import script from "./FilesSearch.vue?vue&type=script&lang=js"
export * from "./FilesSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports